import * as React from "react"

const useBoolean = (initialState: boolean) => {
  const [state, setState] = React.useState<boolean>(initialState)
  const toggle = React.useCallback(() => setState((p) => !p), [])
  const setStateWithValue = React.useCallback((value: boolean) => () => setState(value), [])
  const enable = React.useCallback(() => setState(true), [])
  const disable = React.useCallback(() => setState(false), [])
  return { state, toggle, setState, setStateWithValue, enable, disable }
}

export { useBoolean }
